import axios from 'axios';
import {
  hashTriibo1,
  validateRegistrationDate,
  generateRandom,
} from 'js/library/utils/helpers.jsx';
import cfac22 from '../cfac22';

export function getChannelToken_v1(uId) {
  return new Promise((resolve, reject) => {
    //capturando dados do Storage
    const channelObj = JSON.parse(localStorage.getItem('channelToken'));

    const valideDate = validateRegistrationDate(
      !channelObj ? null : channelObj.registrationDate,
      15
    );
    const channelUId = !channelObj ? null : channelObj.uId;

    //token não existe no storage
    if (
      !channelObj ||
      channelObj.id === null ||
      channelObj.id === '' ||
      channelObj.id === undefined ||
      !valideDate ||
      channelUId === undefined ||
      channelUId === null ||
      channelUId !== uId
    ) {
      const passPhrase = generateRandom(10);
      const challenge = hashTriibo1(cfac22('apiToken'), passPhrase, cfac22('channeltoken'));

      axios
        .post(
          cfac22('API_HOST_V1') + 'getChannelToken_v1',
          {
            triiboHeader: {
              apiToken: cfac22('apiToken'),
              channelGroup: cfac22('channelGroup'),
              channelName: cfac22('channelName'),
              uId: uId,
              passPhrase: passPhrase,
              challenge: challenge,
              channelId: cfac22('channelId'),
            },
          },
          {
            headers: {
              'Full-Url': window.location.href,
            },
          }
        )
        .then(() => {
          //console.log('RESULTADO GET CHANNEL TOKEN', result);
          localStorage.setItem(
            'channelToken',
            '{ "id":"' +
              challenge +
              '", "registrationDate":' +
              Date.now() +
              ', "uId":"' +
              uId +
              '" }'
          );

          resolve(challenge);
        })
        .catch((error) => {
          //console.log('ERRO GET CHANNEL TOKEN', error);
          reject(error);
        });
    }
    //token existe no storage
    else {
      resolve(channelObj.id);
    }
  });
}
